import { AxiosInstance } from 'axios';
import i18n from 'i18next';
import { redirect } from 'react-router-dom';
import { NotificationToast } from '../../components/organisms/notification-toast';
import Cookies from '../../lib/cookies';

// Handler for connection errors
export const setConnectionInterceptor = (axios: AxiosInstance) => {
	axios.interceptors.response.use(
		(res) => {
			return res;
		},
		(error) => {
			if (!error?.response) {
				NotificationToast.Warn(i18n.t('alert.error.connection'));
			} else throw error;
		}
	);
};

// Handler for connection, unauthorized and forbidden errors
export const setDefaultInterceptor = (axios: AxiosInstance) => {
	axios.interceptors.response.use(
		(res) => {
			return res;
		},
		(error) => {
			if (!error?.response) {
				NotificationToast.Warn(i18n.t('alert.error.connection'));
			} else if (error?.response?.status === 401) {
				NotificationToast.Warn(i18n.t('alert.error.session_expired'));
				Cookies.remove();
				throw redirect('/login');
			} else if (error?.response?.status === 403) {
				NotificationToast.Warn(i18n.t('alert.error.forbidden'));
			} else throw error;
		}
	);
};
